import React from 'react'

const PILPending = ({ color = '#F59E0B', size = 20 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="8.5" fill={color} />
      <path
        d="M10 6.5V11"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="10" cy="14" r="1" fill="white" />
    </svg>
  )
}

export default PILPending